import { funifierApi } from "./api";

export async function getRegulation() {
  try {
    const { data } = await funifierApi.get(`database/settings__c/terms`);
    return data;
  } catch (err) {
    return [];
  }
}